import httpClient from '../utils/axios'
import {
    handleServiceError,
    handleServiceResponse,
} from '../utils/serviceResponseHelper'

async function getAllRoles() {
    try {
        const response = await httpClient.get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/userroles/`
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

export default {
    getAllRoles,
}
